<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.displayName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small>{{ organisation.name }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 16rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/profile').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t("Profile.Title")}}</span>
          </li>
          <li
            v-if="multipleOrganisations"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="chooseOrganisation()"
          >
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Switch organisation</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <dx-popup
      :title="this.$t('Organisation.Choose')"
      v-bind:visible.sync="organisationChooseActive"
      :width="600"
      height="auto"
      :drag-enabled="true"
      :close-on-outside-click="true"
      :show-close-button="true"
      :show-title="true"

    >
      <organisation-choose
        :showPopup.sync="organisationChooseActive"
      />
    </dx-popup>
  </div>
  
</template>

<script>
import authService from '@/auth/authService'
import { DxPopup } from 'devextreme-vue/popup'
import { notifyMixin } from '@/mixins/notifyMixin'
import OrganisationChoose from '../../../../views/organisation/OrganisationChoose'
export default {
  data () {
    return {
      organisationChooseActive : false
    }
  },
  components: {
    DxPopup,
    OrganisationChoose
  },
  computed: {
    multipleOrganisations () {
      return this.$store.state.AppActiveUser.organisations.length > 1
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    organisation () {
      const activeOrganisationId = this.$store.state.AppActiveUser.activeOrganisationId
      const organisation = this.$store.state.AppActiveUser.organisations.find(org => {
        return org.id === activeOrganisationId
      }
      )
      if (organisation) {
        return organisation
      }
      return { id: 0, name: "Onbekend", role: "", logoUrl: "" }
    }
  },
  methods: {
    chooseOrganisation () {
      console.log('sssss')
      this.organisationChooseActive = true
    },
    logout () {
      authService.logout()
      this.$router.push('/login').catch(() => { })
    }
  }
}
</script>
